import {
  resolveAIProviderId,
  THREE_B_AI_PROVIDER_ID,
} from "../../shared/aiProviders";
import { queries } from "../../shared/queries";
import { managedAiProviderLocked } from "../lib/session";
import { config } from "../environment";
import { useQuery } from "@rocicorp/zero/react";

// The environment-managed AI provider and its per-tenant disable state:
// `locked` when the deployment forces it off (not admin-changeable), `disabled`
// when either the lock or the tenant admin toggle turns it off, and `hidden`
// once a 3B managed AI provider is the tenant default and replaces it.
// `availableProvider` is undefined while disabled or hidden, so defaults and
// model pickers skip it.
export function useManagedAIProvider() {
  const managedProvider = config.managedAIProvider;
  const locked = managedAiProviderLocked();
  const [tenant, tenantResult] = useQuery(queries.currentTenant());
  const [activeProvider] = useQuery(queries.activeAIProvider());
  const disabled = locked || tenant?.managedAiProviderDisabledAt != null;
  const hidden =
    activeProvider != null &&
    resolveAIProviderId(activeProvider) === THREE_B_AI_PROVIDER_ID;
  return {
    managedProvider,
    locked,
    disabled,
    hidden,
    availableProvider: disabled || hidden ? undefined : managedProvider,
    managedChatModel: tenant?.managedAiChatModel ?? null,
    managedEffort: tenant?.managedAiEffort ?? null,
    // Stored managed defaults are null until this resolves; seeding the modal
    // before then would overwrite real config with the defaults.
    tenantLoaded: tenantResult?.type === "complete",
  };
}
